import Box from '@mui/material/Box';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import List from '@mui/material/List';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Typography from '@mui/material/Typography';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { StateItem } from './StateItem';
import type { DistrictDropdownProps } from './types';

export const DistrictDropdown = ({
  open,
  anchorRef,
  filtered,
  expanded,
  selected,
  query,
  toggleExpand,
  handleSelectDistrict,
  handleClose,
}: DistrictDropdownProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Popper
      open={open}
      anchorEl={anchorRef.current}
      placement="bottom-start"
      disablePortal
      style={{
        width: anchorRef.current?.clientWidth,
        zIndex: 2,
        visibility: 'visible',
        position: 'absolute',
      }}
    >
      <Grow
        in={open}
        style={{
          transformOrigin: 'top left',
        }}
      >
        <Paper sx={{ mt: 0, boxShadow: 3, borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
          <ClickAwayListener onClickAway={handleClose}>
            <Box>
              <List disablePadding sx={{ maxHeight: '300px', overflow: 'auto' }}>
                {filtered.map(state => (
                  <StateItem
                    key={state.id}
                    state={state}
                    isOpen={!!expanded[state.id]}
                    selected={selected}
                    query={query}
                    onToggleExpand={toggleExpand}
                    onSelectDistrict={handleSelectDistrict}
                  />
                ))}
              </List>

              {filtered.length === 0 && (
                <Box
                  sx={{
                    p: 2,
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    sx={{
                      color: 'text.secondary',
                    }}
                  >
                    {t('No districts match your search')}
                  </Typography>
                </Box>
              )}
            </Box>
          </ClickAwayListener>
        </Paper>
      </Grow>
    </Popper>
  );
};
